import React from 'react';

import ApiKeyCard from './subcomponents/apiKeyCard';
import ApiCard from './subcomponents/apiCard';

const ApiSettings = () => (
  <>
    <ApiKeyCard />
    <ApiCard />
  </>
);

export default ApiSettings;
